var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('bulldozerr-wizard-tabs',{ref:"WizardTab",attrs:{"loading":_vm.loading},on:{"save":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }